import * as React from "react";
import { IInfiniteProps } from "./infinite-interface";
import { ContainerHOC, SortHOC, MatchHOC, MoveableHOC, GroupHOC } from "./infinite-hocs";
import { InfiniteLoading } from "./infinite-loading";
import { InfiniteBase as Base } from "./infinite-base";
import { InfiniteApi as Api } from "./infinite-api";

export class Infinite extends React.PureComponent<IInfiniteProps, {}> {
    private api;
    private _base;

    constructor(props) {
        super(props);
        this.api = new Api();
    }

    bindBase = (ref) => (this._base = ref);

    handleBaseForceUpdate = () => {
        this._base.forceUpdate();
    };

    render() {
        const {
            containerHeight,
            containerWidth,

            items,
            allItems,
            snapshotItems,
            searchTerm,
            searchableFields,
            filters,
            sortDirection,
            sortKey,
            sortType,

            groupKey,
            groupDirection,
            groupRenderer,
            onGetGroupDisplayInfo,
            comparator,
            groupHeaders,
            schema,

            sortable,
            onDragEnd,
            onClick,

            cellRenderer,
            onGetCellDisplayInfo,
            itemIdPath,

            onLoadMore,
            isFetching,
            hasMoreResults,
            infinite,
            centered,
            gutterWidth,
            maxWidth = Number.POSITIVE_INFINITY,

            allocationDimensions,
            dimensionFilters,
            tileSettings,
            tileViewSize,
            visualOffset,
            groupItemsOverride,
        } = this.props;
        return (
            <ContainerHOC containerHeight={containerHeight} api={this.api} containerWidth={containerWidth}>
                {({ scrollTop, isScrolling, scrollingContainer }) => (
                    <React.Fragment>
                        <MatchHOC
                            items={items}
                            searchTerm={searchTerm}
                            searchableFields={searchableFields}
                            filters={filters}
                        >
                            {(matchedItems) => (
                                <SortHOC
                                    items={matchedItems}
                                    sortKey={sortKey}
                                    sortDirection={sortDirection}
                                    sortType={sortType}
                                >
                                    {(sortedItems) => (
                                        <GroupHOC
                                            allocationDimensions={allocationDimensions}
                                            api={this.api}
                                            dimensionFilters={dimensionFilters}
                                            items={sortedItems}
                                            groupKey={groupKey}
                                            groupDirection={groupDirection}
                                            groupRenderer={groupRenderer}
                                            groupItemsOverride={groupItemsOverride}
                                            onGetGroupDisplayInfo={onGetGroupDisplayInfo}
                                            scrollingContainer={scrollingContainer}
                                            comparator={comparator}
                                            groupHeaders={groupHeaders}
                                            schema={schema}
                                        >
                                            {({ groupedItems, isGrouped }) => (
                                                <MoveableHOC
                                                    api={this.api}
                                                    items={sortedItems}
                                                    originalItems={items}
                                                    allItems={allItems}
                                                    snapshotItems={snapshotItems}
                                                    sortable={sortable}
                                                    onDragEnd={onDragEnd}
                                                    scrollingContainer={scrollingContainer}
                                                    containerHeight={containerHeight}
                                                    containerWidth={containerWidth}
                                                    itemIdPath={itemIdPath}
                                                    cellRenderer={cellRenderer}
                                                    onGetCellDisplayInfo={onGetCellDisplayInfo}
                                                    onClick={onClick}
                                                    visualOffset={visualOffset || 0}
                                                >
                                                    {({ mousePositionOnPage, draggingId }) => (
                                                        <Base
                                                            items={sortedItems}
                                                            snapshotItems={snapshotItems}
                                                            groupedItems={groupedItems}
                                                            groupKey={groupKey}
                                                            scrollTop={scrollTop}
                                                            containerHeight={containerHeight}
                                                            containerWidth={containerWidth}
                                                            api={this.api}
                                                            cellRenderer={cellRenderer}
                                                            onGetCellDisplayInfo={onGetCellDisplayInfo}
                                                            itemIdPath={itemIdPath}
                                                            isScrolling={isScrolling}
                                                            mousePositionOnPage={mousePositionOnPage}
                                                            isGrouped={isGrouped}
                                                            isSortable={sortable && items === sortedItems}
                                                            draggingId={draggingId}
                                                            ref={this.bindBase}
                                                            infinite={infinite}
                                                            centered={centered}
                                                            maxWidth={maxWidth}
                                                            gutterWidth={gutterWidth || 0}
                                                            tileSettings={tileSettings}
                                                            tileViewSize={tileViewSize}
                                                        />
                                                    )}
                                                </MoveableHOC>
                                            )}
                                        </GroupHOC>
                                    )}
                                </SortHOC>
                            )}
                        </MatchHOC>
                        <InfiniteLoading
                            api={this.api}
                            onLoadMore={onLoadMore}
                            isFetching={isFetching}
                            hasMoreResults={hasMoreResults}
                        />
                    </React.Fragment>
                )}
            </ContainerHOC>
        );
    }
}
